"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosTrackRequest = void 0;
var AxiosQon_1 = require("../../utils/AxiosQon");
var AxiosTrackRequest = /** @class */ (function () {
    function AxiosTrackRequest(config) {
        this.config = config;
        this.axios = (new AxiosQon_1.AxiosQon(config)).axiosInstance;
    }
    AxiosTrackRequest.prototype.sendView = function (url) {
        return this.axios.get(url);
    };
    AxiosTrackRequest.prototype.sendClick = function (url) {
        return this.axios.get(url);
    };
    AxiosTrackRequest.prototype.sendTransaction = function (url) {
        return this.axios.get(url);
    };
    AxiosTrackRequest.prototype.sendTrackingInformation = function (url) {
        return this.axios.get(url);
    };
    return AxiosTrackRequest;
}());
exports.AxiosTrackRequest = AxiosTrackRequest;
//# sourceMappingURL=AxiosRequest.js.map